import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  const benefits = ['El álbum completo listo para imprimir', 'Todas las figuritas de todos los equipos', 'Las figuritas especiales incluidas', 'Sin sobres, sin repetidas, sin esperas', 'Desde tu computadora o celular', 'En minutos, no en semanas'];
  return <section className="py-20 bg-wc-blue text-white relative overflow-hidden" data-id="element-249">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-250">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-wc-yellow rounded-full blur-3xl" data-id="element-251"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-wc-red rounded-full blur-3xl" data-id="element-252"></div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-254">
          <h2 className="text-4xl md:text-6xl text-wc-yellow mb-6" data-id="element-255">
            ✨ LA SOLUCIÓN IDEAL
          </h2>
          <p className="text-2xl md:text-3xl font-medium" data-id="element-256">
            ¿Y si pudieras tener HOY:
          </p>
        </motion.div>

        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl" data-id="element-257">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-258">
            {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4" data-id="element-259">
                <CheckCircle2 className="w-8 h-8 text-green-400 flex-shrink-0 mt-1" data-id="element-260" />
                <span className="text-xl font-medium" data-id="element-261">{benefit}</span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="mt-12 text-center" data-id="element-262">
            <p className="text-2xl md:text-4xl font-display text-wc-yellow tracking-wide" data-id="element-263">
              Eso es exactamente el MEGAPACK ÁLBUM MUNDIAL 2026.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}